module.exports = __webpack_public_path__ + "img/1XBET.43df669a.svg";